import { BsCircleFill } from "react-icons/bs";

const TopicSelection = ({ selection }) => (
  <div className="dropdown-selection">
    <BsCircleFill size="10" className="text-gray-400 mr-4" />
    <h5 className="dropdown-selection-text">{selection}</h5>
  </div>
);

export default TopicSelection;
